import Axios from 'api/client';
import { User } from 'types/domain';

interface UserResponse {
    data: User;
    launchdarkly_hash: string | null;
    intercom_hash: string | null;
    growsurf_hash: string | null;
    segment_object:
        | (User & {
              raised: string;
              campaigns: number;
              highest_account_role: string;
          })
        | null;
}

const fetchUser = () =>
    Axios.get<UserResponse>(`/user`, {
        params: {
            without: 'menu',
        },
    }).then(response => response.data);

const updateProfileInformation = (firstName: string, lastName: string, email: string) =>
    Axios.put('user/profile-information', {
        first_name: firstName,
        last_name: lastName,
        email,
    });

export { fetchUser, updateProfileInformation };
